// src/styles/apolloTheme.js
// Shared Apollo design tokens (CSS variable references)

const apollo = {
    transition: {
        fast: 'all var(--pallium-transition-fast)',
        normal: 'all var(--pallium-transition-normal)',
    },
    radius: {
        sm: 'var(--pallium-border-radius-sm)',
        default: 'var(--pallium-border-radius)',
        md: 'var(--pallium-border-radius-md)',
        lg: 'var(--pallium-border-radius-lg)',
        xl: 'var(--pallium-border-radius-xl)',
        pill: '9999px',
    },
    shadow: {
        xs: 'var(--pallium-shadow-xs)',
        sm: 'var(--pallium-shadow-sm)',
        md: 'var(--pallium-shadow-md)',
        lg: 'var(--pallium-shadow-lg)',
    },
    z: {
        dropdown: 'var(--pallium-z-dropdown)',
    },
    focusRing: 'var(--pallium-focus-ring-primary)',
    color: {
        primary: 'var(--pallium-primary-purple)',
        primaryDark: 'var(--pallium-purple-6)',
        white: 'var(--pallium-white)',
        black: 'var(--pallium-black)',
        success: 'var(--pallium-success-green)',
        error: 'var(--pallium-error-red)',
        warning: 'var(--pallium-warning-yellow)',
        info: 'var(--pallium-info-cyan)',
        textPrimary: 'var(--pallium-text-primary)',
        textSecondary: 'var(--pallium-text-secondary)',
        textDisabled: 'var(--pallium-text-disabled)',
        iconGray: 'var(--pallium-icon-gray)',
        borderDefault: 'var(--pallium-border-default)',
        borderSubtle: 'var(--pallium-border-subtle)',
        bgPrimary: 'var(--pallium-bg-primary)',
        bgSecondary: 'var(--pallium-bg-secondary)',
        selectedBg: 'var(--pallium-selected-option-bg)',
        purple1: 'var(--pallium-purple-1)',
        purple05: 'var(--pallium-purple-0-5)',
        linkDefault: 'var(--pallium-link-default)',
        linkHover: 'var(--pallium-link-hover)',
        buttonPrimaryBg: 'var(--pallium-button-primary-bg)',
        buttonPrimaryHover: 'var(--pallium-button-primary-hover)',
        darkNavy: 'var(--pallium-primary-dark-navy)',
        strokeLight: 'var(--pallium-stroke-light)',
    },
};

export default apollo;
